import QuoteBox from "./components/QuoteBox";
import "./index.css";

function App() {
  return (
    <div>
      <QuoteBox />
    </div>
  );
}

export default App;
